import React from "react";

/**
 * FloatingOrbs — reusable decorative depth layer.
 *
 * Renders a few large, blurred, slowly-floating radial-gradient orbs in the
 * brand swampy green/teal. Purely decorative (aria-hidden, pointer-events:none)
 * and CSS-animated — no per-frame JS. Drop it as the first child of any
 * position:relative section to add layered depth behind the content.
 *
 * Styles live in src/pages/home/home-theme.css (.nz-orbs / .nz-orb*).
 *
 * @param {string} [className] extra classes for placement/opacity tweaks
 * @param {boolean} [grid] also render the faint perspective grid layer
 */
const FloatingOrbs = ({ className = "", grid = false }) => (
  <div className={`nz-orbs ${className}`} aria-hidden="true">
    {grid && <span className="nz-grid" />}
    <span className="nz-orb nz-orb--green nz-orb--a" />
    <span className="nz-orb nz-orb--teal nz-orb--b" />
    <span className="nz-orb nz-orb--mint nz-orb--c" />
  </div>
);

export default FloatingOrbs;
